import { IServerStatus } from "app/modules/remote-control-ng/definitions";
import { MemoryBuffer } from "../../utils/memoryBuffer"
import { BaseMessage } from "../baseMessage"

/** SAC_SERVER_STATUS SotiAssistMessageType */
export class ServerStatusMessage extends BaseMessage {
    public response: IServerStatus = <IServerStatus>{};

    public deserializeBody(buffer: MemoryBuffer): void {
        this.response.status = buffer.readInt32BE();
        this.response.message = buffer.readString();
    }
}
